import { DialogConfig } from '@agent-ds/shared/components/dialog/dialog-config';
import { DialogRef } from '@agent-ds/shared/components/dialog/dialog-ref';
import { Component } from '@angular/core';
import {
  CustomerFilterCondition,
  CustomerFilterDefinition,
} from './customer-filter-button-and-dialog.component';

interface EditableCustomerFilterCondition {
  key: string;
  value: string | number | unknown[] | null;
}

interface CustomerFilterDialogData {
  filterDefinitions: CustomerFilterDefinition[];
  currentConditions: CustomerFilterCondition[];
}

@Component({
  selector: 'ag-customer-filter-dialog',
  templateUrl: './customer-filter-dialog.component.html',
  styleUrls: ['./customer-filter-dialog.component.scss'],
})
export class CustomerFilterDialogComponent {
  filterDefinitions: CustomerFilterDefinition[] = [];
  draftConditions: EditableCustomerFilterCondition[] = [];

  constructor(public dialog: DialogRef, public config: DialogConfig<CustomerFilterDialogData>) {
    this.filterDefinitions = config.data && config.data.filterDefinitions ? config.data.filterDefinitions : [];
    const currentConditions = config.data && config.data.currentConditions ? config.data.currentConditions : [];
    this.draftConditions = this.filterDefinitions.map((definition) => {
      const currentCondition = currentConditions.find((condition) => condition.key === definition.key);

      return {
        key: definition.key,
        value: currentCondition ? currentCondition.value : null,
      };
    });
  }

  close(): void {
    this.dialog.close();
  }

  clearConditions(): void {
    this.dialog.close([]);
  }

  applyConditions(): void {
    const validKeys = new Set(this.filterDefinitions.map((definition) => definition.key));
    const conditions = this.draftConditions
      .filter((condition) => validKeys.has(condition.key))
      .filter((condition) => condition.value !== null && condition.value !== '')
      .map((condition) => ({
        key: condition.key,
        value: condition.value,
      }));

    this.dialog.close(conditions);
  }

  getDefinition(key: string): CustomerFilterDefinition | undefined {
    return this.filterDefinitions.find((definition) => definition.key === key);
  }

  trackByIndex(index: number): number {
    return index;
  }
}
